import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

import type { TableBaseColumnType } from '@/components/TableBase/Body';
import type { PublicApiSettingsJson } from '@/domain/payment/service/entity/publicApiSettingsEntity';

import TableBase from '@/components/TableBase';
import { service } from '@/share';

/**
 * プロパティ
 */
export type Props = {
  /** 閉じる */
  close: () => void,
  /** 施設ID */
  nurseryId: string,
}

const SCTActDialog: React.FC<Props> = ({
  close,
  nurseryId,
}) => {
  const [id, setId] = React.useState<
    { data: PublicApiSettingsJson | undefined } | undefined
  >(undefined);
  React.useEffect(() => {
    if (id === undefined) {
      const execProcess = async () => {
        const data = await service.payment.getApiSettings(nurseryId);
        setId({ data });
      };
      execProcess();
    }
  }, [nurseryId, id]);
  const rows = [
    { id: 'sctActActor', name: '販売業者', content: id?.data?.sctActActor || '' },
    { id: 'sctActSupervisor', name: '代表責任者', content: id?.data?.sctActSupervisor || '' },
    { id: 'sctActAddress', name: '所在地', content: id?.data?.sctActAddress || '' },
    { id: 'sctActTel', name: '電話番号', content: id?.data?.sctActTel || '' },
    { id: 'sctActTelTime', name: '電話受付時間', content: id?.data?.sctActTelTime || '' },
    { id: 'sctActEmail', name: 'メールアドレス', content: id?.data?.sctActEmail || '' },
    { id: 'sctActSiteUrl', name: 'サイトURL', content: 'https://wagako.life' },
    { id: 'sctActPrice', name: '商品の販売価格', content: id?.data?.sctActPrice || '' },
    { id: 'sctActPriceOther', name: '商品代金以外に必要な料金', content: id?.data?.sctActPriceOther || '' },
    { id: 'sctActHowToPay', name: '支払方法', content: id?.data?.sctActHowToPay || '' },
    { id: 'sctActPaymentTerm', name: '支払時期', content: id?.data?.sctActPaymentTerm || '' },
    { id: 'sctActDeliveryTime', name: '商品の引渡時期', content: id?.data?.sctActDeliveryTime || '' },
    { id: 'sctActExchange', name: '返品・交換', content: id?.data?.sctActExchange || '' },
    { id: 'sctActExchangeFee', name: '返品送料', content: id?.data?.sctActExchangeFee || '' },
  ];
  const columns: TableBaseColumnType[] = [
    { id: 'name', label: '名称' },
    { id: 'content', label: '内容' },
  ];
  return (
    <Dialog open>
      <DialogTitle style={{ textAlign: 'center' }}>
        特定商取引法に基づく表記
      </DialogTitle>
      <DialogContent>
        <TableBase
          rows={rows}
          columns={columns}
          actions={[]}
          isPagination={false}
          isShowFilter={false}
          isShowFooter={false}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button
          onClick={() => close()}
        >
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SCTActDialog;
